module.exports = __webpack_public_path__ + "static/media/profile-style-img2.877e02db.png";